function Navigation_form_edit(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    fieldRewrite: '.js-field-rewrite',
	    containerNewWindow: '.js-new-window',
	    checkboxNewWindow: '.js-checkbox-new-window',
	    checkboxPublished: '.js-checkbox-published',
	    containerPublishing: '.js-container-publishing'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded'
    };

    this.init = function() {
	    // console.log('init - Navigation_form_edit');

	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$fieldRewrite = this.$element.find(this.selectors.fieldRewrite);
	    this.$containerNewWindow = this.$element.find(this.selectors.containerNewWindow);
	    this.$checkboxNewWindow = this.$element.find(this.selectors.checkboxNewWindow);
	    this.$checkboxPublished = this.$element.find(this.selectors.checkboxPublished);
	    this.$containerPublishing = this.$element.find(this.selectors.containerPublishing);

		this.$fieldRewrite.on('i4:change', this.$onChangeRewrite.bind(this));
		this.$checkboxPublished.on('i4:change', this.$onChangePublishing.bind(this));

		this.$formParent.on(this.triggers.afterLoaded, (function() {
			this.$onChangeRewrite();
			this.$onChangePublishing();
		}).bind(this));
    };

    this.$onChangeRewrite = function() {
    	if (this.$fieldRewrite.val().indexOf('http://') === 0) {
    		this.$containerNewWindow.show();
	    } else {
	    	this.$containerNewWindow.hide();
	    	this.$checkboxNewWindow.prop('checked', false);
	    }
    };

    this.$onChangePublishing = function() {
    	if (this.$checkboxPublished.is(':checked')) {
			this.$containerPublishing.show();
		} else {
			this.$containerPublishing.hide();
		}
    };
}
